import React from 'react';
import * as s from './customer-journey-timeline.module.less';
import * as landingPageStyle from '../landing-page.module.less';
import Pane from '../../pane/pane';
import PaneTitle from '../../pane/pane-title/pane-title';
import cn from "classnames";
import assignmentImg from "../../../media/landing-page/project/assignment.png";
import briefingImg from "../../../media/landing-page/project/briefing.png";
import goLiveImg from "../../../media/landing-page/project/go-live.png";
import implementationImg from "../../../media/landing-page/project/implementation.png";
import milestoneBasisImg from "../../../media/landing-page/project/milestone-basis.png";
import monitoringImg from "../../../media/landing-page/project/monitoring.png";
import onlineWorkshopImg from "../../../media/landing-page/project/online-workshop.png";
import testingImg from "../../../media/landing-page/project/testing.png";
import timeBasisImg from "../../../media/landing-page/project/time-basis.png";
import workshopImg from "../../../media/landing-page/project/workshop.png";

const journeySteps = [
  {
    title: "1. Kostenloses Erstgespräch",
    img: onlineWorkshopImg,
    description: "Sie schildern uns Ihre Idee und Ihre idealen Vorstellungen."
  },
  {
    title: "2. Kostenloser Technologievorschlag",
    img: testingImg,
    description: "Wir recherchieren kostenlos und schlagen Ihnen die passende Technologie für Ihren Prototyp vor."
  },
  {
    title: "3. Kickoff Call",
    img: briefingImg,
    description: "In einem gemeinsamen Call verstehen wir alle Anforderungen, die Sie an Ihren Prototyp haben."
  },
  {
    title: "4. Design Vorschlag",
    img: monitoringImg,
    description: "Sie erhalten von uns einen ersten Designvorschlag für Ihren Prototyp."
  },
  {
    title: "5. Prototyp Entwicklung",
    img: implementationImg,
    description: "Wir entwickeln den interaktiven Prototyp nach Ihren Anforderungen."
  },
  {
    title: "6. Abnahme & Übergabe",
    img: goLiveImg,
    description: "Gemeinsame Abnahme des Prototyps und Übergabe aller relevanten Daten."
  }
];

const CustomerJourneyTimeline = ({ heading = "Der Prozess: Von der Idee zum Prototyp", description = "So einfach läuft die Zusammenarbeit mit uns ab:" }) => {
  return (
    <Pane style={{ backgroundColor: '#f9f9f9' }}> {/* Light background */}
      <div className={landingPageStyle.container}>
        <PaneTitle title={heading} description={description} isCentered />
        <div className={s.journeyContainer}>
          {journeySteps.map((step, stepIndex) => {
            return (
                <div className={cn(s.journeyStep, {
                  [s.reverse]: stepIndex % 2 !== 0,
                  [s.firstStep]: stepIndex === 0,
                  [s.lastStep]: stepIndex === journeySteps.length - 1,
                })}>
                  <div className={cn(s.ruler, {
                    [s.hide]: stepIndex === 0,
                  })}>
                    <hr />
                    <div className={s.dot}/>
                  </div>
                  <div className={s.journeyStepContent}>
                    <div className={s.imagePlaceholder}>
                      <img src={step.img} alt={step.name}/>
                    </div>
                    <div className={s.stepMainContent}>
                      <div className={s.stepNumber}>{stepIndex + 1}</div>
                      <h4>{step.title}</h4>
                      <p>{step.description}</p>
                    </div>
                  </div>
                </div>
            )
          })}
        </div>
      </div>
    </Pane>
  )
      ;
};

export default CustomerJourneyTimeline;
